import styled from "styled-components";
import { default as BaseCheckbox } from "../../../common/Checkbox";

export const Placeholder = styled.div`
  width: 100%;
  height: 51rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[200]};

  ${({ theme }) => theme.media.sm`
    height: 30rem;
  `}
`;

export const Legends = styled.div`
  margin-top: 3rem;
  position: relative;
`;

export const Legend = styled.label`
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  line-height: 1.7rem;
  margin: 1.5rem 0 0;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  cursor: pointer;

  &:first-child {
    margin-top: 0;
  }
`;

export const LegendIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 1.2rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const LegendIconCircle = styled(LegendIcon)`
  background-color: ${({ theme, isFilled }) =>
    isFilled
      ? theme.styleGuide.colors.gray[700]
      : theme.styleGuide.colors.white};
  border: 0.2rem solid ${({ theme }) => theme.styleGuide.colors.gray[800]};
  border-radius: 50%;
  position: relative;
  z-index: 1;
`;

export const LegendSubjectPropertyIcon = styled(LegendIcon)`
  svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: ${({ theme }) => theme.styleGuide.colors.suite[500]};
  }
`;

export const LegendIconDivider = styled.div`
  &:after {
    content: "";
    width: 0.2rem;
    background-color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
    transform: translateX(-50%);
    position: absolute;
    left: 0.8rem;
    top: 0.2rem;
    bottom: 0.2rem;
    z-index: 0;
  }
`;

export const Checkbox = styled(BaseCheckbox)`
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 1.6rem;

  @media print {
    display: none;
  }
`;
